// Structured Data (JSON-LD) templates for Union Center

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Union Center",
  url: "https://www.3716union.com",
  logo: "https://www.3716union.com/img/resources/union_logo_white.png",
  address: {
    "@type": "PostalAddress",
    streetAddress: "37-16 Union Street",
    addressLocality: "Flushing",
    addressRegion: "NY",
    postalCode: "11354",
    addressCountry: "US",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1-646-889-9988",
    contactType: "Sales",
    email: "unioncenter3716@gmail.com",
    areaServed: "US",
    availableLanguage: "English",
  },
  sameAs: [
    // Add social media links if available
  ],
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "CommercialBuilding",
  name: "Union Center",
  image: "https://www.3716union.com/img/resources/union_side.jpg",
  address: {
    "@type": "PostalAddress",
    streetAddress: "37-16 Union Street",
    addressLocality: "Flushing",
    addressRegion: "NY",
    postalCode: "11354",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "40.7614",
    longitude: "-73.8291",
  },
  telephone: "+1-646-889-9988",
  email: "unioncenter3716@gmail.com",
  url: "https://www.3716union.com",
  description:
    "Union Center is a 133,000 square foot state-of-the-art Class A office building in Downtown Flushing, NY, featuring modern amenities, sustainable design, and prime location near public transportation.",
  numberOfFloors: 15,
  floorSize: {
    "@type": "QuantitativeValue",
    value: "133000",
    unitCode: "SQM",
  },
};

export const placeSchema = {
  "@context": "https://schema.org",
  "@type": "Place",
  name: "Union Center",
  address: {
    "@type": "PostalAddress",
    streetAddress: "37-16 Union Street",
    addressLocality: "Flushing",
    addressRegion: "NY",
    postalCode: "11354",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "40.7614",
    longitude: "-73.8291",
  },
};

export const realEstateAgentSchema = {
  "@context": "https://schema.org",
  "@type": "RealEstateAgent",
  name: "Union Center",
  address: {
    "@type": "PostalAddress",
    streetAddress: "37-16 Union Street",
    addressLocality: "Flushing",
    addressRegion: "NY",
    postalCode: "11354",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "40.7614",
    longitude: "-73.8291",
  },
};

export const breadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
};

